import {createFileRoute} from '@tanstack/react-router';

import {tagKeys} from '@/features/Library/api/queryKeys';
import {getTag} from '@/features/Library/api/readTag';
import {TagModal} from '@/features/Library/components/Tag/TagModal';
import {makeDocumentTitle} from '@/utils/makeDocumentTitle';

export const Route = createFileRoute('/_b/_p/_library/tags/$tagId')({
  component: TagModal,

  beforeLoad: ({params, context}) => {
    makeDocumentTitle(params.tagId);

    return {
      ...context,
      readTagQuery: {
        queryKey: tagKeys.detail(params.tagId),
        queryFn: () => getTag(params.tagId),
      },
    };
  },

  loader({context}) {
    return context.queryClient.ensureQueryData(context.readTagQuery);
  },
});
